export enum SphereModeEnum {
  ALL = 'ALL', // INCLUDE COMPLETE AND MINI
  COMPLETE = 'COMPLETE', // ONLY COMPLETE RECORDS
  MINI = 'MINI', // ONLY MINI RECORD
}
